// extracted by mini-css-extract-plugin
module.exports = {"bm-empty":"bm-empty"};